import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Divider } from '@/components/ui/divider'
import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'

import * as S from './survey-details-panel.styled'
import { SurveyDetailsPanelData } from './survey-details-panel.types'
import { getSurveyDetailsPanelFields } from './survey-details-panel.utils'

export interface SurveyDetailsPanelProps {
  data: SurveyDetailsPanelData
}

export const SurveyDetailsPanel = ({ data }: SurveyDetailsPanelProps) => {
  const { t } = useTranslation(['communication'])
  const fields = useMemo(() => getSurveyDetailsPanelFields(data, t), [data, t])

  return (
    <S.Container>
      <S.InfoGrid>
        {fields.map(({ label, value, icon }) => (
          <S.InfoField key={label}>
            <Icon icon={icon} size="2rem" color="black100" />
            <S.InfoFieldText>
              <Typography color="black800" size="text-small" weight="semibold">
                {label}
              </Typography>
              <Typography color="black500" size="text-small" weight="medium">
                {value}
              </Typography>
            </S.InfoFieldText>
          </S.InfoField>
        ))}
      </S.InfoGrid>
      <Divider light />
      <S.QuestionsSection>
        <Typography color="black600" size="text-small" weight="bold">
          {t('communication:surveyDetails.panel.questions')}
        </Typography>
        {data.questions.map((question) => (
          <Typography key={question} color="black500" size="text-small" weight="medium">
            {question}
          </Typography>
        ))}
      </S.QuestionsSection>
    </S.Container>
  )
}
